import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import HeroContent from '~/components/hero/HeroContent';

import Image from '~/components/base/Image';
import Lottie from '~/components/Lottie';

import { AcfLink, AcfBackgroundColor } from '~/utilities/propTypes';
import { calcVw } from '~/styles/helpers';

const BackgroundImage = styled(Image)`
    position: absolute;
    width: ${calcVw(100)};
    top: 0;
    left: 50%;
    right: 50%;
    bottom: 0;
    margin: 0 ${calcVw(-50)};
    z-index: ${({ theme }) => theme.zIndex.backgroundImage};
`;

const LottieWrapper = styled.div`
    position: absolute;
    width: ${calcVw(100)};
    top: 0;
    left: 50%;
    right: 50%;
    bottom: 0;
    margin: 0 ${calcVw(-50)};
    z-index: ${({ theme }) => theme.zIndex.backgroundImage};
    overflow: hidden;
`;

const BackgroundLottie = styled(Lottie)`
    width: 100%;
    height: 100%;

    > svg {
        height: 100%;
        width: auto !important;

        @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
            height: auto !important;
            width: auto !important;
            min-height: 100%;
            max-width: 100%;
        }
    }
`;

const PhotoTextBox = ({
    backgroundImage = null,
    backgroundImageType = 'image',
    lottieJson = null,
    backgroundColor = 'black',
    title,
    copy = '',
    ctasVariant = 'ctas',
    ctas = [],
    appLinks = []
}) => (
    <>
        {backgroundImage ? (
            <BackgroundImage {...backgroundImage} objectPosition="top" />
        ) : null}

        {lottieJson && backgroundImageType === 'animation' ? (
            <LottieWrapper>
                <BackgroundLottie lottieJson={lottieJson} />
            </LottieWrapper>
        ) : null}

        <HeroContent
            contentTextBox
            contentPlacement="center"
            columnSpan={6}
            {...{
                backgroundColor,
                title,
                copy,
                ctasVariant,
                ctas,
                appLinks
            }}
        />
    </>
);

PhotoTextBox.propTypes = {
    ...AcfBackgroundColor,
    backgroundImage: PropTypes.shape({}),
    backgroundImageType: PropTypes.oneOf(['image', 'animation']),
    lottieJson: PropTypes.string,
    title: PropTypes.string.isRequired,
    copy: PropTypes.string,
    ctasVariant: PropTypes.string,
    ctas: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string,
            link: AcfLink
        })
    ),
    appLinks: PropTypes.arrayOf(
        PropTypes.shape({
            linkUrl: PropTypes.string,
            badge: PropTypes.shape({})
        })
    )
};

export default PhotoTextBox;
